import React from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import { Select, Input, Button, notification } from "antd";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Strings from "utils/strings";
import { ContentWrapper } from "components";
import { getSuccessLevelBadge } from "utils/utils";
import { API, Endpoints } from "utils/api";

const { Option } = Select;

export class SendEmail extends React.Component<any, any> {
	constructor(props: any) {
		super(props);
		this.state = {
			recipients: [],
			subject: "",
			content: "",
			sending: false,
			error: null
		};
	}

	handleRecipientsChange = (recipients: string[]) => {
		this.setState({ recipients });
	};

	handleSubjectChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		this.setState({ subject: e.target.value });
	};

	handleEditorChange = (content: string) => {
		this.setState({ content: content });
	};

	handleSend = async () => {
		const { recipients, subject, content } = this.state;
		if (!recipients.length || !subject || !content) {
			notification.warn({
				message: Strings.sidebar.emails,
				description: Strings.profile.editedSuccessfully,
				placement: "bottomRight",
				duration: 5
			});
			return;
		}
		this.setState({ sending: true });

		try {
			const response = await API.post({
				url: Endpoints.uriPartners("send-email-to-rank"),
				data: {
					recipients,
					subject,
					content
				}
			});

			if (response?.ok) {
				this.setState({ sending: false, recipients: [], subject: "", content: "" });
				notification.success({
					message: Strings.sidebar.emails,
					description: Strings.emails.sentSuccessfully,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: Strings.serverErrors.title,
				description: (err as string) || Strings.serverErrors.wentWrong,
				placement: "bottomRight",
				duration: 5
			});
		}
	};

	render() {
		const { recipients, subject, content, sending } = this.state;

		// Example options, replace with your real user list
		const ranksOptions = [
			"junior",
			"executive",
			"special-executive",
			"bronze",
			"silver",
			"gold",
			"gold30",
			"gold60",
			"gold100",
			"ruby",
			"emerald",
			"diamond",
			"diamond2",
			"diamond4",
			"diamond6",
			"diamond8",
			"special-diamond"
		];

		return (
			<div>
				<Helmet>
					<title>{Strings.emails.sendEmail}</title>
					<meta name="description" content="Send email" />
				</Helmet>
				<ContentWrapper>
					<h2>{Strings.emails.sendEmail}</h2>
					<div>
						<div style={{ marginBottom: 16 }}>
							<label>{Strings.emails.recipients}</label>
							<Select
								mode="multiple"
								allowClear
								style={{ width: "100%" }}
								placeholder={Strings.emails.selectRecipients}
								value={recipients}
								onChange={this.handleRecipientsChange}
							>
								{ranksOptions.map((opt) => (
									<Option key={opt} value={opt}>
										{getSuccessLevelBadge(opt)}
									</Option>
								))}
							</Select>
						</div>
						<div style={{ marginBottom: 16 }}>
							<label>{Strings.emails.subject}</label>
							<Input value={subject} onChange={this.handleSubjectChange} placeholder={Strings.emails.subject} />
						</div>
						<div style={{ marginBottom: 16 }}>
							<label>{Strings.emails.content}</label>
							<ReactQuill
								value={content}
								onChange={this.handleEditorChange}
								theme="snow"
								style={{ height: 200, marginBottom: 16 }}
							/>
						</div>
						<Button type="primary" style={{ marginTop: "2rem" }} loading={sending} onClick={this.handleSend} disabled={sending}>
							{Strings.generic.send}
						</Button>
					</div>
				</ContentWrapper>
			</div>
		);
	}
}

const mapStateToProps = (state: any) => ({
	selectedBusiness: state.selectedBusiness,
	language: state.language,
	user: state.user
});

export default connect(mapStateToProps)(SendEmail);
